import { normalizeHostname } from "./host_root_landing";

/** Preferred public product host for Shared Continuity Room (path slug URLs). */
export const SHARED_CONTINUITY_ROOM_PRODUCT_HOST_PRIMARY = "room.xo-vault.com";

/** Alternate host that serves the same SPA mapping. */
export const SHARED_CONTINUITY_ROOM_PRODUCT_HOST_FALLBACK = "rooms.xo-vault.com";

/** Default slug when visiting the room product root (`/` or `/?room=` empty). */
export const SHARED_CONTINUITY_ROOM_DEFAULT_SLUG = "demo";

const SHARED_CONTINUITY_ROOM_PRODUCT_HOSTS = new Set([
  SHARED_CONTINUITY_ROOM_PRODUCT_HOST_PRIMARY,
  `www.${SHARED_CONTINUITY_ROOM_PRODUCT_HOST_PRIMARY}`,
  SHARED_CONTINUITY_ROOM_PRODUCT_HOST_FALLBACK,
  `www.${SHARED_CONTINUITY_ROOM_PRODUCT_HOST_FALLBACK}`,
]);

/** True when this hostname should mount the dedicated Shared Continuity Room route tree (not `/continuity-room` on the hub). */
export function isSharedContinuityRoomProductHost(hostname: string | undefined): boolean {
  if (!hostname) return false;
  return SHARED_CONTINUITY_ROOM_PRODUCT_HOSTS.has(normalizeHostname(hostname));
}
